export class ProviderGroupVM {
  id: any;
  name?: string;
}
